import * as React from "react";
import {makeStyles, Select as MUISelect, SelectProps} from "@material-ui/core";
import {InputBaseStyle, MenuStyle, SelectStyle} from "@components/common/select/select.style";

const selectStyles = makeStyles(SelectStyle);
const menuStyles = makeStyles(MenuStyle);
const inputBaseStyles = makeStyles(InputBaseStyle);
const Select = (props: SelectProps) => {

    return (<MUISelect
        {...props}
        classes={{
            ...props.classes,
            ...selectStyles(),
        }}
        MenuProps={{
            ...props.MenuProps,
            classes: {
                ...props.MenuProps?.classes,
                ...menuStyles()
            },
            anchorOrigin: {
                vertical: "bottom", // Display the popover below the select
                horizontal: "left", // Align the left edge of the popover with the left edge of the select
            },
            transformOrigin: {
                vertical: "top", // Align the top edge of the popover with the bottom edge of the select
                horizontal: "left", // Align the left edge of the popover with the left edge of the select
            },
            getContentAnchorEl: null, // Disable default behavior of trying to find the anchor element
        }}
        inputProps={{
            ...props.inputProps,
            classes: {
                ...props.inputProps?.classes,
                ...inputBaseStyles(),

            }
        }}
        variant="outlined"
    />);
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/common/select/Select.tsx